export default "__VITE_ASSET__BdO6KdXf__"